import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as React from 'react';
import { buttonOpen } from './veggieBurgerButtonStyles';
const VeggieBurgerButton = React.forwardRef(function ({ children, cssOverride, ...otherProps }, ref) {
    return (_jsx("button", { css: [buttonOpen, cssOverride], ref: ref, ...otherProps, children: children }));
});
VeggieBurgerButton.defaultProps = {
    'aria-haspopup': false,
};
export default VeggieBurgerButton;
